module.exports = __webpack_public_path__ + "static/img/Itu2@2x.3261a101.png";